// extracted by mini-css-extract-plugin
module.exports = {"listaTarefas":"style_listaTarefas__oFvqE"};